import axios from 'axios';
import i18n from '../services/i18n';

const API = axios.create({
     baseURL: process.env.REACT_APP_BASE_API_URL+'/api',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization':'Bearer '+localStorage.getItem("xller_token")??""
    }
});

// Lets the backend translate course/category content into the site language.
API.interceptors.request.use((config) => {
    config.headers['X-Locale'] = (i18n.resolvedLanguage || i18n.language || 'en').slice(0, 2);
    return config;
});

export default API;
